/**
 * Contrato do Ponto de Venda (venda rápida) com o kali-core-backend.
 * Espelha os DTOs de financeiro/dto/pdv e cadastro/dto/ProdutoPdvDTO.
 * BigDecimal do core chega como number no JSON.
 */

/** GET /cadastro/produto/codigo-barra/{codigo} (ProdutoPdvDTO). */
export interface ProdutoPdv {
  id: number;
  nomeProduto: string;
  descricao: string;
  codigoBarra: string;
  unMedida: string | null;
  permiteFracionado: boolean;
  precoUnitario: number;
}

/** PdvItemDTO: preço e total sempre calculados no servidor. */
export interface PdvItem {
  produtoId: number;
  nome: string;
  unMedida: string | null;
  precoUnitario: number;
  quantidade: number;
  total: number;
}

/** PdvVendaDTO. */
export interface PdvVenda {
  id: number;
  status: string;
  clienteAnonimo: boolean;
  nomeCliente: string | null;
  itens: PdvItem[];
  subtotal: number;
  descontoPercentual: number | null;
  desconto: number;
  valorTotal: number;
  descontoMaximoPercentual: number;
}

/** PdvVendaCriarDTO. Sem idVendedor usa o Vendedor Padrão; sem idCliente = anônimo. */
export interface PdvCriarRequest {
  chaveIdempotencia: string;
  idVendedor?: number | null;
  idCliente?: number | null;
}

/** PdvItemEntradaDTO: somente produto e quantidade (sem preço/total). */
export interface PdvItemEntrada {
  produtoId: number;
  quantidade: number;
}

/** PdvAtualizarItensDTO. descontoPercentual nulo = sem desconto. */
export interface PdvAtualizarItensRequest {
  itens: PdvItemEntrada[];
  descontoPercentual: number | null;
}

/** PdvFinalizarDTO: dados para montar o OrcamentoDTO do venda-modal-v2. */
export interface PdvFinalizarResponse {
  id: number;
  idCliente: number;
  idVendedor: number;
  nomeCliente: string | null;
  descontoAplicado: number;
  valorTotal: number;
  restricaoAtiva: boolean | null;
}

/** Códigos de erro do PDV (ExceptionEnum do core, 400-26..400-32). */
export const PDV_ERROS = {
  PRODUTO_CODIGO_BARRA_DUPLICADO: '400-26',
  PDV_TRANSICAO_INVALIDA: '400-27',
  PDV_DESCONTO_ACIMA_LIMITE: '400-28',
  PDV_QUANTIDADE_INVALIDA: '400-29',
  PDV_EMPRESA_NAO_CONFIGURADA: '400-30',
  PDV_EMPRESA_CNPJ_INVALIDO: '400-31',
  PDV_VENDEDOR_PADRAO_INVALIDO: '400-32',
} as const;

export type PdvErroCodigo = (typeof PDV_ERROS)[keyof typeof PDV_ERROS];

/** Códigos de erro da leitura por código de barras (ExceptionEnum do core). */
export const PDV_ERROS_LEITURA = {
  PRODUTO_NAO_ENCONTRADO: '404-02',
  PRODUTO_SEM_PRECO: '400-04',
  PRODUTO_CODIGO_BARRA_DUPLICADO: PDV_ERROS.PRODUTO_CODIGO_BARRA_DUPLICADO,
} as const;
